<div class="angular-editor-toolbar" *ngIf="showToolbar">

  <!-- Undo / Redo -->
  <div class="angular-editor-toolbar-set" *ngIf="!isButtonHidden('undo') || !isButtonHidden('redo')">
    <button *ngIf="!isButtonHidden('undo')" type="button" title="Undo" class="angular-editor-button" (click)="triggerCommand('undo')" tabindex="-1">
      <span class="material-icons">undo</span>
    </button>
    <button *ngIf="!isButtonHidden('redo')" type="button" title="Redo" class="angular-editor-button" (click)="triggerCommand('redo')" tabindex="-1">
      <span class="material-icons">redo</span>
    </button>
  </div>

  <!-- Text Formatting -->
  <div class="angular-editor-toolbar-set"
       *ngIf="!isButtonHidden('bold') || !isButtonHidden('italic') || !isButtonHidden('underline') || !isButtonHidden('strikeThrough') || !isButtonHidden('subscript') || !isButtonHidden('superscript')">
    <button *ngIf="!isButtonHidden('bold')" [id]="'bold-' + id" type="button" title="Bold" class="angular-editor-button" (click)="triggerCommand('bold')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">format_bold</span>
    </button>
    <button *ngIf="!isButtonHidden('italic')" [id]="'italic-' + id" type="button" title="Italic" class="angular-editor-button" (click)="triggerCommand('italic')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">format_italic</span>
    </button>
    <button *ngIf="!isButtonHidden('underline')" [id]="'underline-' + id" type="button" title="Underline" class="angular-editor-button" (click)="triggerCommand('underline')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">format_underlined</span>
    </button>
    <button *ngIf="!isButtonHidden('strikeThrough')" [id]="'strikeThrough-' + id" type="button" title="Strikethrough" class="angular-editor-button" (click)="triggerCommand('strikeThrough')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">strikethrough_s</span>
    </button>
    <button *ngIf="!isButtonHidden('subscript')" [id]="'subscript-' + id" type="button" title="Subscript" class="angular-editor-button" (click)="triggerCommand('subscript')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">subscript</span>
    </button>
    <button *ngIf="!isButtonHidden('superscript')" [id]="'superscript-' + id" type="button" title="Superscript" class="angular-editor-button" (click)="triggerCommand('superscript')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">superscript</span>
    </button>
  </div>

  <!-- Alignment -->
  <div class="angular-editor-toolbar-set"
       *ngIf="!isButtonHidden('justifyLeft') || !isButtonHidden('justifyCenter') || !isButtonHidden('justifyRight') || !isButtonHidden('justifyFull')">
    <button *ngIf="!isButtonHidden('justifyLeft')" [id]="'justifyLeft-' + id" type="button" title="Align Left" class="angular-editor-button" (click)="triggerCommand('justifyLeft')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">format_align_left</span>
    </button>
    <button *ngIf="!isButtonHidden('justifyCenter')" [id]="'justifyCenter-' + id" type="button" title="Align Center" class="angular-editor-button" (click)="triggerCommand('justifyCenter')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">format_align_center</span>
    </button>
    <button *ngIf="!isButtonHidden('justifyRight')" [id]="'justifyRight-' + id" type="button" title="Align Right" class="angular-editor-button" (click)="triggerCommand('justifyRight')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">format_align_right</span>
    </button>
    <button *ngIf="!isButtonHidden('justifyFull')" [id]="'justifyFull-' + id" type="button" title="Justify" class="angular-editor-button" (click)="triggerCommand('justifyFull')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">format_align_justify</span>
    </button>
  </div>

  <!-- Indent -->
  <div class="angular-editor-toolbar-set" *ngIf="!isButtonHidden('indent') || !isButtonHidden('outdent')">
    <button *ngIf="!isButtonHidden('indent')" [id]="'indent-' + id" type="button" title="Indent" class="angular-editor-button" (click)="triggerCommand('indent')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">format_indent_increase</span>
    </button>
    <button *ngIf="!isButtonHidden('outdent')" [id]="'outdent-' + id" type="button" title="Outdent" class="angular-editor-button" (click)="triggerCommand('outdent')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">format_indent_decrease</span>
    </button>
  </div>

  <!-- Lists -->
  <div class="angular-editor-toolbar-set" *ngIf="!isButtonHidden('insertUnorderedList') || !isButtonHidden('insertOrderedList')">
    <button *ngIf="!isButtonHidden('insertUnorderedList')" [id]="'insertUnorderedList-' + id" type="button" title="Bullet List" class="angular-editor-button" (click)="triggerCommand('insertUnorderedList')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">format_list_bulleted</span>
    </button>
    <button *ngIf="!isButtonHidden('insertOrderedList')" [id]="'insertOrderedList-' + id" type="button" title="Numbered List" class="angular-editor-button" (click)="triggerCommand('insertOrderedList')" [disabled]="htmlMode" tabindex="-1">
      <span class="material-icons">format_list_numbered</span>
    </button>
  </div>

  <!-- Color -->
  <div class="angular-editor-toolbar-set" *ngIf="!isButtonHidden('textColor') || !isButtonHidden('backgroundColor')">

    <input class="hidden-input"
           type="color"
           (change)="insertColor(fgInput.value, 'textColor')"
           #fgInput>

    <button *ngIf="!isButtonHidden('textColor')" type="button" class="angular-editor-button"
            (click)="focus(); fgInput.click()"
            title="Text Color">
      <span class="material-icons">format_color_text</span>
    </button>

    <input class="hidden-input"
           type="color"
           (change)="insertColor(bgInput.value, 'backgroundColor')"
           #bgInput>

    <button *ngIf="!isButtonHidden('backgroundColor')" type="button" class="angular-editor-button"
            (click)="focus(); bgInput.click()"
            title="Background Color">
      <span class="material-icons">format_color_fill</span>
    </button>

  </div>

  <!-- File Input -->
  <input
         class="hidden-input"
         accept="image/*"
         type="file"
         (change)="onFileChanged($event)"
         #fileInput>

  <!-- Media -->
  <div class="angular-editor-toolbar-set"
       *ngIf="!isButtonHidden('link') || !isButtonHidden('unlink') || !isButtonHidden('insertImage') || !isButtonHidden('insertVideo')">
    <button *ngIf="!isButtonHidden('link')" [id]="'link-' + id" type="button" title="Insert Link" class="angular-editor-button" (click)="insertUrl()">
      <span class="material-icons">link</span>
    </button>
    <button *ngIf="!isButtonHidden('unlink')" [id]="'unlink-' + id" type="button" title="Unlink" class="angular-editor-button" (click)="triggerCommand('unlink')">
      <span class="material-icons">link_off</span>
    </button>
    <button *ngIf="!isButtonHidden('insertImage')" type="button" title="Insert Image" class="angular-editor-button" (click)="focus(); fileInput.click()">
      <span class="material-icons">image</span>
    </button>
    <button *ngIf="!isButtonHidden('insertVideo')" type="button" title="Insert Video" class="angular-editor-button" (click)="insertVideo()">
      <span class="material-icons">videocam</span>
    </button>
  </div>

  <!-- Clear -->
  <div class="angular-editor-toolbar-set" *ngIf="!isButtonHidden('removeFormat')">
    <button type="button" title="Clear Formatting" class="angular-editor-button" (click)="triggerCommand('removeFormat')">
      <span class="material-icons">format_clear</span>
    </button>
  </div>

  <!-- Code -->
  <div class="angular-editor-toolbar-set" *ngIf="!isButtonHidden('toggleEditorMode')">
    <button [id]="'toggleEditorMode-' + id" type="button" title="HTML Code" class="angular-editor-button" (click)="triggerCommand('toggleEditorMode')">
      <span class="material-icons">code</span>
    </button>
  </div>

  <ng-content></ng-content>
</div>
